import Container from './StudioHeaderMobile.container';
import StudioHeaderMobile from './StudioHeaderMobile';

export default Container(StudioHeaderMobile);
